/**
 * Pure helpers for the sidebar ↔ route audit.
 *
 * A sidebar href is covered only by a real <Route path="...">. The catch-all
 * `*` is not a page — it is the bug that used to send every unknown link to
 * /dashboard — so it never counts as a match.
 */

export function collectNavHrefs(nodes, acc = []) {
  const list = Array.isArray(nodes) ? nodes : [nodes];
  for (const node of list) {
    if (!node) continue;
    if (Array.isArray(node)) {
      collectNavHrefs(node, acc);
      continue;
    }
    if (typeof node.href === 'string' && node.href) acc.push(node.href);
    if (node.children) collectNavHrefs(node.children, acc);
  }
  return acc;
}

/**
 * Module slugs the sidebar actually renders. Derived from nav items so the
 * super-admin fallback cannot drift from a second hard-coded list.
 */
export function moduleKeysFromNav(nodes) {
  const keys = new Set();
  const walk = (items) => {
    const list = Array.isArray(items) ? items : [items];
    for (const node of list) {
      if (!node) continue;
      if (Array.isArray(node)) {
        walk(node);
        continue;
      }
      if (node.module) keys.add(node.module);
      if (Array.isArray(node.modules)) node.modules.forEach((key) => keys.add(key));
      if (node.children) walk(node.children);
    }
  };
  walk(nodes);
  return [...keys].sort();
}

export function routePatternMatches(route, pathname) {
  if (!route || route === '*') return false;
  const routeSegments = route.split('/').filter(Boolean);
  const pathSegments = String(pathname).split('?')[0].split('/').filter(Boolean);
  if (routeSegments.length !== pathSegments.length) return false;
  return routeSegments.every((segment, index) => (
    segment.startsWith(':') || segment === pathSegments[index]
  ));
}

export function hrefCoveredByRoutes(href, routes) {
  const pathname = String(href).split('?')[0];
  return routes.some((route) => routePatternMatches(route, pathname));
}
